import { Component } from '@angular/core';
import { Placement } from '@popperjs/core';
import { VIEWER_MODE } from './../toggle/toggle.enum';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent {
  title = "Heading 1";
  subtitle = "Heading 2";
  titleSpanish = "Título 1";
  subtitleSpanish = "Título 2";
  titleHindi = "शीर्षक 1";
  subtitleHindi = "शीर्षक 2";
  isMultiStepModal = true;
  backUrl = "/card";
  cancelUrl = "/button";
  isSmallContentModal = true;
  selectedPlacement: Placement = 'bottom';
  defaultHeading = 'Default Heading';
  toggleNgModel: string = VIEWER_MODE.TOGGLE_MODE_1;
  public toggleMode2 = VIEWER_MODE.TOGGLE_MODE_2;
  public role = 'switch';
}